"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const loadingModal = (message) => {
    let loadingModal = document.querySelector("#loading-modal");
    let loadingModalMessage = document.querySelector("#loading-modal-message");
    if (message) {
        loadingModal.classList.remove("display-none");
        loadingModalMessage.innerHTML = message;
    }
    else {
        loadingModal.classList.add("display-none");
    }
};
exports.default = loadingModal;
